import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/dashboards/$id')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
